import {
    MAJ_CLUB_SELECTED,
    REMOVE_CLUB_SELECTED,
    ADD_TO_ALL_CLUBS_SELECTED,
    REMOVE_FROM_ALL_CLUBS_SELECTED,
    REINIT_ALL_CLUBS_SELECTED
} from '../mutations-type'
var _ = require('underscore');

// initial state
const state = {
    clubSelected: null,
    allClubsSelected: []
}

// mutations
const mutations = {
    [MAJ_CLUB_SELECTED] (state, club) {
        state.clubSelected = club
    },
    [REMOVE_CLUB_SELECTED] (state) {
        state.clubSelected = null
    },
    [ADD_TO_ALL_CLUBS_SELECTED] (state, info) {
        if (!_.contains(state.allClubsSelected, {club: info.club, role: info.role}))
            state.allClubsSelected.push({club: info.club, role: info.role})
    },
    [REMOVE_FROM_ALL_CLUBS_SELECTED] (state, info) {
        var index = _.findIndex(state.allClubsSelected, {club: info.club, role: info.role})
        if (index >= 0)
            state.allClubsSelected.splice(index, 1)
    },
    [REINIT_ALL_CLUBS_SELECTED] (state) {
        state.allClubsSelected=[]
    }
}

const actions = {

    reinitAllClubsSelected({commit}) {
        commit(REINIT_ALL_CLUBS_SELECTED)
    },
    majClubSelected({commit}, user) {
        commit(MAJ_CLUB_SELECTED, user)
    },
    removeClubSelected({commit}) {
        commit(REMOVE_CLUB_SELECTED)
    },
    addToAllClubsSelected({commit}, info) {
        commit(ADD_TO_ALL_CLUBS_SELECTED,info)
    },
    removeFromAllClubsSelected({commit},info) {
        commit(REMOVE_FROM_ALL_CLUBS_SELECTED,info)
    }
    // mappingBadges({commit}, badges) {
    //     commit(MAPPING_BADGES, badges)
    // },

}

const getters = {
    getClubSelected : state => {
        return state.clubSelected;
    },
    getAllClubsSelected : state => {
        return _.groupBy(state.allClubsSelected, function (item) {
            return item.role.role
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/searchClub.js